export enum LoginError {
    Credentials = 'credentials',
    Unconfirmed = 'unconfirmed',
    NotApproved = 'not_approved',
    Unknown = 'unknown'
}
